<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="9">
            <h3>Perguntas Frequentes</h3>
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{ usuarioLogado.nome }}</p>
            <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
            <p><b>Estado:</b> {{ usuarioLogado.estado }}</p>
            <p><b>Município:</b> {{ usuarioLogado.municipio }}</p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row v-if="listCards.data">
          <b-col md="12" v-for="card in listCards.data" :key="card.id">
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle="card.id" id="pergunta" variant="secondary"
                    ><span>{{card.pergunta.toUpperCase()}}</span> <i class="fa fa-sort-desc"></i></b-button>
                </b-card-header>
                <b-collapse
                  :id="card.id"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      {{card.resposta.toUpperCase()}}
                    </b-card-text>
                    <b-card-text>{{ text }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-col>
        </b-row>
        <b-row class="text-center" v-else
          ><h4>Nenhum registro de faq...</h4></b-row
        >
      </b-card-body>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'
import Pagination from '@/components/shared/PaginationAvaliacoes'

miniToastr.init()

export default {
  name: 'Depoimentos',
  components: {
    AuthTemplate,
    Pagination
  },
  created () {
    this.$store.dispatch('buscarMunicipiosProgramas')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      listCards: [],
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      }
    }
  },
  watch: {
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
      this.usuarioLogado.nome = this.usuario.nome
    },
    municipiosprogramas: function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    }
  },
  mounted () {
    Vue.http.get('api/faqs-list').then((response) => {
      this.listCards = response.body.data
    })
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    }
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
#pergunta i{
  font-size: 25px;
  padding-right: 10px;
}
#pergunta{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/faq/ListFaq.vue